import styled, { createGlobalStyle } from 'styled-components';

import icoReact from '../assets/ico-react.svg';
import icoCsharp from '../assets/ico-csharp.svg';
import icoDefault from '../assets/ico-default.svg';

export const uri =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:3000'
        : 'http://lab.yeza.com.br';

export const IcoReact = icoReact;

export const IcoCsharp = icoCsharp;

export const IcoNoLanguage = icoCsharp;

export const color = {
    primary: '#EABD00',
    secondary: '#1D120E',
    'c#': '#68217A',
    javascript: '#64DFFC',
    default: '#7953F8',
};

export const ico = {
    'c#': IcoCsharp,
    javascript: IcoReact,
    default: icoDefault,
};

export default createGlobalStyle`

    *{
        margin: 0;
        padding: 0;
        outline:0;
        box-sizing: border-box;
    }

    body{
        background: ${color.secondary};
        color:#FFF;
        -webkit-font-smoothing: antialiased;
    }

    body, input, button{
        font: 14px sans-serif;
    }

    button{
        cursor: point
    }
`;

export const Header = styled.header`
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ProjectList = styled.ul`
    width: 90%;
    max-width: 1120px;
    margin: 0 auto 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(272.5px, 1fr));
    grid-gap: 10px;
`;
